import { gql } from '@apollo/client';

export const GET_ALL_LOCATIONS = gql`
  query GET_ALL_LOCATIONS {
    getAllLocations {
      id
      name
    }
  }
`;